(function(window, externalMessageController, playerConfiguration, iFrameBridge, windowWrapper) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.queryParamsStripper = (function() {
      var parsePlayerURLParams = function(queryString) {
         var playerUrlParams = queryString.slice(queryString.indexOf('?') + 1).split('&');
         if (playerUrlParams && playerUrlParams.length > 0) {
            playerConfiguration.saveConfigurationFromQueryString(playerUrlParams);
         }
      };

      var requestEmbeddedURLParams = function() {
         externalMessageController.addCallback('PARENT-URL-PARAMS', parseEmbeddedURLParams);
         iFrameBridge.postMessage('GET-EMBEDDED-URL-VARS', '*');
      };

      var parseEmbeddedURLParams = function(data) {
         externalMessageController.removeCallback('PARENT-URL-PARAMS');
         parsePlayerURLParams(data);
      };

      return {
         strip: function() {
            parsePlayerURLParams(windowWrapper.getLocationHref());
            if (iFrameBridge.isInIframe()) {
               requestEmbeddedURLParams();
            }
         }
      };
   }());
}(this, window.TSC.externalMessageController, window.TSC.playerConfiguration, window.TSC.iFrameBridge, window.TSC.windowWrapper));
